import FrameProvider from './FrameProvider';
import BroadwayFrameProviderWorker from './broadway/BroadwayFrameProvider.worker';
import { getSharedSessionToken } from '../../centralDispatch/sessionToken';
import { isNil } from '../../../util/object';
import { RasteredImageBitmapInterface } from '../RasteredImageBitmapInterface';
import { FrameProviderPrioritizationInterface } from './FrameProviderPrioritizationInterface';
import { NUM_FRAMES_TO_BUFFER } from '../constants';

export default class Mp4FrameProvider extends FrameProvider {
  /**
   * @constructor Creates BroadwayFrameProviderWorker, which is used as a wrapper to communicate with the underlying
   * BroadwayFrameProvider running inside the instantiated worker.
   * @return {Mp4FrameProvider}
   */
  constructor() {
    super();
    this._numberOfBufferedFrames = NUM_FRAMES_TO_BUFFER;
    this._broadwayFrameProviderWorker = new BroadwayFrameProviderWorker();
    // TODO: Deploy smarter way to send shared session token
    this._broadwayFrameProviderWorker.postMessage({
      type: 'init',
      sharedSessionToken: getSharedSessionToken(),
    });

    this._broadwayFrameProviderWorker.onmessage = (event) => {
      const data = event.data;
      if (data.type === RasteredImageBitmapInterface.identifier) {
        // Ensure we are getting the right message
        this.onRasterImage(data);
      }
    };
  }

  cleanup = () => {
    this._broadwayFrameProviderWorker.terminate();
  };

  /**
   * @function fetchFrames
   * @param  {FrameProviderPrioritizationInterface} frameProviderPrioritizationInterface
   */
  fetchFrames = (frameProviderPrioritizationInterface) => {
    this._broadwayFrameProviderWorker.postMessage(
      FrameProviderPrioritizationInterface.createTransferrable(
        frameProviderPrioritizationInterface.videoFile,
        frameProviderPrioritizationInterface.unavailableFrameRanges,
        this.resolution,
      ),
    );
  };

  /**
   * @function onRasterImage Callback for when an image is rastered. Notifies frame ready listeners.
   * @param  {RasteredImageBitmapTransferrable} rasteredImageBitmapTransferrable
   */
  onRasterImage = (rasteredImageBitmapTransferrable) => {
    if (isNil(rasteredImageBitmapTransferrable)) return;
    const rasteredImageBitmapInterface = RasteredImageBitmapInterface.fromTransferrable(
      rasteredImageBitmapTransferrable,
    );
    this.notifyFrameReadyListeners(rasteredImageBitmapInterface);
  };
}
